const getters = {
  scWorkPivots: state => state.sc_work_pivots,
  scWorkHierarchy: state => state.sc_work_hierarchy,
  scWorkPivot: state => state.sc_work_pivot,
  scWorkPivotFilters: state => state.sc_work_pivot_filters,
}

export default getters;
